// extracted by mini-css-extract-plugin
export default {"index":"AnnotationList_index__SzJqJ","paragraph":"AnnotationList_paragraph__SoHNH","timestamp":"AnnotationList_timestamp__Clnmj"};